/* eslint-disable */
import { FunctionComponent, InputHTMLAttributes } from 'react';
import styles from '../../../styles/components/pageComponents/manageUsers/CoachManageUsersSearchbar.module.css';

interface CoachManageUsersSearchbarProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	placeholder?: string;
	disabled?: boolean;
	className?: string;
}

const CoachManageUsersSearchbar: FunctionComponent<
	CoachManageUsersSearchbarProps
> = ({
	value,
	onChange,
	placeholder = 'Search Users',
	disabled = false,
	className = '',
	...rest
}) => {
	return (
		<div
			className={`${styles.coachManageUsersSearchbar} ${
				disabled ? styles.disabled : ''
			} ${className}`}
		>
			{/* Search Icon */}
			<svg
				className={styles.icon}
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
			>
				<path
					d="M21 21L16.65 16.65M11 19C6.58 19 3 15.42 3 11C3 6.58 6.58 3 11 3C15.42 3 19 6.58 19 11C19 15.42 15.42 19 11 19Z"
					stroke="#949494"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>

			<input
				type="text"
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				disabled={disabled}
				className={styles.input}
				{...rest}
			/>
		</div>
	);
};

export default CoachManageUsersSearchbar;
